import React, { memo } from "react";

const SkeletonImg = () => {
    return (
        <div className="absolute h-full w-full bg-light-color animate-pulse"></div>
    );
};

export default memo(SkeletonImg);
